package org.hs_soft.runmynesto.data.api_datasource.product.tabs.tab_restaurant

import com.varabyte.kobweb.browser.http.AbortController
import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.encodeToJsonElement
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.create_product_addition.ProductAdditionModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_restaurant.CreateProductAdditionRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_restaurant.delete_addition.DeleteAdditionModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_restaurant.DeleteProductAdditionRepository


class DeleteProductAdditionRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
): DeleteProductAdditionRepository {

    private var currentAbortController:AbortController?=null

    override suspend fun deleteProductAddition(
        id:String,
    ): DeleteAdditionModel {

        currentAbortController = requestManager.createController()


        val graphQLQuery = buildJsonObject {
            put("query", """
                 mutation deleteProductAddition(${'$'}id: ID!) {
                   cashAssist {
                     deleteProductAddition(id:${'$'}id) {
                       ${ApiUtils.Field.id}
                       ${ApiUtils.Field.__typename}
                     }
                     ${ApiUtils.Field.__typename}
                   }
                 }

            """.trimIndent())

            putJsonObject("variables") {
                put("id", id)
            }

        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = currentAbortController!!,
        )

        return if (result != null) {
            Json.decodeFromString<DeleteAdditionModel>(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }


    }

    override fun cancel() {
        currentAbortController?.abort()
        currentAbortController = null
    }

}
